import type { AssetDataType } from '@repo/types/asset';
import { isOrder } from '@repo/types/order';

export const selectPaymentDetails = (data?: AssetDataType) => {
    const paymentData = isOrder(data) ? data.assetDetails._embedded?.paymentPlans : undefined;

    const currentPaymentData = paymentData?.find((payment) => payment.dueDateTime !== undefined);
    const paymentTiming = currentPaymentData?.timing;
    const paymentStatus = currentPaymentData?.status;
    const paymentType = currentPaymentData?.type;

    const paymentDueDate = currentPaymentData?.dueDateTime ?? '';

    const isPaymentDateEditable = Boolean(
        currentPaymentData &&
        (paymentStatus === 'UNPAID' || paymentStatus === 'PARTLY_PAID' || paymentStatus === 'UNDERPAID') &&
        paymentType === 'CASH' &&
        paymentTiming === 'ON_DATE'
    );

    return {
        paymentData,
        currentPaymentData,
        paymentTiming,
        paymentDueDate,
        isPaymentDateEditable,
    };
};
